// import Main from '@/view/main'

export default {
  path: "report",
  meta: {
    title: "报表"
  },
  component: () => import("@/components/parent-view"),
  children: [
    {
      path: "sale",
      name: "report-sale",
      meta: {
        title: "销售报表"
      },
      component: () => import("@/view/v5/report/sale/index.vue")
    },
    {
      path: "purchase",
      name: "report-purchase",
      meta: {
        title: "采购报表"
      },
      component: () => import("@/view/v5/report/purchase/index.vue")
    },
    {
      path: "finance",
      name: "report-finance",
      meta: {
        title: "财务报表"
      },
      component: () => import("@/view/v5/report/finance/index.vue")
    },
    {
      path: "paymentLedger",
      name: "paymentLedger",
      meta: {
        title: "收付款台账"
      },
      component: () => import("@/view/v5/report/paymentLedger/index.vue")
    },
    {
      path: "invoice",
      name: "report-invoice",
      meta: {
        title: "发票台账"
      },
      component: () => import("@/view/v5/report/invoice/index.vue")
    }
  ]
};



// WEBPACK FOOTER //
// ./src/router/routes/v5/report.js